import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import SearchTablePagination from "./search-table-pagination.js";

function mapStateToProps(state) {
  return {
    searchObj: state.searchObj,
    texts: state.translatedTexts,
    simulatedUserDetails: state.simulatedUserDetails,
    isSimulateMode: state.isSimulateMode,
    userDetails: state.userDetails,
    searchTransactionResponse: state.searchTransactionResponse,
    selectedTransactions: state.searchPageComponents.selectedTransactions,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchTablePagination);
